import { H2, IBaseBlockShowResource, RenderView, Section } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Header = styled(H2)`
	padding: ${({ theme }) => theme.spacing(5)} 0;
`;

const StyledSection = styled(Section)`
	display: grid;
	justify-content: center;
	align-items: center;
`;

export const RegistrationFormPrivatePage: FC<{ block: IBaseBlockShowResource | null }> = ({ block }) => {
	const { t } = useTranslation();

	if (block) {
		return <RenderView block={block} />;
	}

	return (
		<StyledSection>
			<Header>{t("Private registration")}</Header>
			<p>{t("This registration is only accessible through a personal invitation.")}</p>
		</StyledSection>
	);
};
